// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2jLHe","modalForm":"UpgradeEpcsModal_modalForm__2PyfZ","modalFooter":"UpgradeEpcsModal_modalFooter__3QuH5"};